import { fork } from 'redux-saga/effects';
import { watchFirstDepositToBonus } from './bonus-messaging/saga';
import { watchConfigs } from './configs/saga';
import { watchIntegrations } from './integrations/saga';
import { watchAppMessages } from './messages/saga';
import { watchTransactions } from './transactions/saga';
import { watchAutoSignIn, watchUser } from './user/saga';

export default function* rootSaga(): any {
  yield fork(watchConfigs);
  yield fork(watchUser);
  yield fork(watchAutoSignIn);
  yield fork(watchAppMessages);
  yield fork(watchTransactions);
  yield fork(watchIntegrations);
  yield fork(watchFirstDepositToBonus);
}
